import { useId, useState } from "react";
import { useHudStore } from "../store/hudStore";
import { DOMAINS } from "../data/seed";
import { Badge, Button, Field, Select } from "../design-system/components";
import type { Quest } from "../types";
import "./QuestForm.css";

export default function EditQuestForm({ quest }: { quest: Quest }) {
  const st = useHudStore();
  const mainHelperId = `quest-edit-main-help-${useId()}`;
  const [attempted, setAttempted] = useState(false);

  return (
    <form className="quest-form quest-form--edit" aria-label={`Edit ${quest.title}`} noValidate onSubmit={(event) => {
      event.preventDefault();
      setAttempted(true);
      if (st.editTitle.trim()) st.saveEdit();
    }}>
      <Field label="Quest title" required value={st.editTitle} onChange={(event) => st.setEditTitle(event.target.value)} placeholder="Quest title" error={attempted && !st.editTitle.trim() ? "Give this quest a title." : undefined} />

      <fieldset className="quest-form-group" aria-describedby={mainHelperId}>
        <legend className="quest-form-label">Main quests</legend>
        <div className="quest-form-picks">
          {st.mains.map((main) => <Button key={main.id} size="compact" variant={st.editMains.includes(main.id) ? "primary" : "secondary"} aria-pressed={st.editMains.includes(main.id)} onClick={() => st.editPickMain(main.id)}>{main.name}</Button>)}
        </div>
        <p id={mainHelperId} className="quest-form-help">The first pick is the primary.</p>
      </fieldset>

      <Select label="Domain" value={st.editDomain} onChange={(event) => st.editPickDomain(event.target.value)}>
        {DOMAINS.map((domain) => <option key={domain.name} value={domain.name}>{domain.name}</option>)}
      </Select>

      <div className="quest-form-footer">
        <div className="quest-form-reward">
          <span className="quest-form-label">Reward</span>
          <div className="quest-form-stepper" role="group" aria-label="Quest XP reward">
            <Button size="compact" icon="fa-solid fa-minus" onClick={st.editXpDown} disabled={st.editXp <= 10} aria-label="Decrease reward by 10 XP" />
            <Badge tone="warning">{st.editXp} XP</Badge>
            <Button size="compact" icon="fa-solid fa-plus" onClick={st.editXpUp} disabled={st.editXp >= 300} aria-label="Increase reward by 10 XP" />
          </div>
        </div>
        <div className="quest-form-actions">
          <Button variant="danger" icon="fa-solid fa-trash" onClick={() => st.removeQuest(quest.id)}>Delete</Button>
          <Button onClick={st.cancelEdit}>Cancel</Button>
          <Button type="submit" variant="primary">Save changes</Button>
        </div>
      </div>
    </form>
  );
}
